import { useEffect } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { trackMovementPageView } from 'src/app/pages/movement/shared/api';
import {
	MOVEMENT_EVENT_VIEW_CONTEXT,
	QUERY_PARAM_MOVEMENT,
	QUERY_PARAM_SOURCE_LOCATION,
} from 'src/app/pages/movement/shared/constants';
import { useQueryParamValue } from 'src/app/shared/hooks/location';

import { useMovementContext } from '../useMovementContext';

export function useMovementViewTracking(): void {
	const track = useTracking();
	const { id: movementId } = useMovementContext();
	const sourceLocation = useQueryParamValue(QUERY_PARAM_SOURCE_LOCATION) || QUERY_PARAM_MOVEMENT;

	useEffect(() => {
		void trackMovementPageView(movementId, sourceLocation, MOVEMENT_EVENT_VIEW_CONTEXT, track);
	}, [movementId, sourceLocation, track]);
}
